import { getIn } from 'formik';
import * as Yup from 'yup';

/**
 * Determines if a field is marked as required in a Yup validation schema.
 *
 * @param validationSchema The Yup validation schema.
 * @param name The path to the field, supporting deep paths with dot notation.
 * @returns {boolean} True if the field is required, false otherwise.
 */
export const isRequiredField = (
  validationSchema: Yup.AnyObjectSchema,
  name: string
): boolean => {
  const schemaDescription = validationSchema.describe();
  const accessor = name.split('.').join('.fields.');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const field: any = getIn(schemaDescription.fields, accessor);

  if (!field) {
    return false;
  }

  return field.optional === false;
};
